import { useQuery } from "@tanstack/react-query";
import Axios from "@/lib/axios-instance";

// API call to get a specific plan feature
export const getBill = async (billId: string) => {
    const response = await Axios.get(`/store_subscription_plan/${billId}`);
    return response.data;
};

// React Query hook
export const useGetbill = (billId: string) => {
    return useQuery({
        queryKey: ["get-bill", billId],
        queryFn: () => getBill(billId),
        enabled: !!billId, // Only run if ID is provided
        retry: 1,
    });
};
